import { useBehaviouralCuesFiltersFeatureFlag } from 'src/store/featureFlags/hooks';
import { selectTags } from 'src/store/location/selectors';
import { useSelector } from 'src/store/react';
import { selectResultsCount } from 'src/store/selectors';

export const useShowResultSummaryWithBehaviouralCuesFiltersEnabled = () => {
  const searchTags = useSelector(selectTags);
  const isNewToYou = searchTags === 'new';
  const isAllTabSearchResultsCountZero = useSelector(selectResultsCount) === 0;
  const isBehaviouralCuesFiltersEnabled =
    useBehaviouralCuesFiltersFeatureFlag();

  if (!isBehaviouralCuesFiltersEnabled) {
    return false;
  }

  return !isAllTabSearchResultsCountZero || isNewToYou;
};
